export enum NoteTypeEnums {
  creditNote = 1,
  debitNote = 2,
  supportDocument = 3
}